module.exports = function (jQuery) {
    (function ($) {
        $.fn.iislider = function (options) {
            "use strict";
            var opts = $.extend({}, $.fn.iislider.defaults, options);
            $.each(this, function () {
                var iisliderCurrentObject = $(this),
                    startslide = true;

                if (opts.startOnHover) {
                    startslide = false;
                    iisliderCurrentObject.waypoint(function () {
                        startslide = true;
                    },{offset: 200})
                }

                function activateSlide(slide) {
                    if ((iisliderCurrentObject.find(":animated").length == 0)) {
                        var slides = iisliderCurrentObject.find(".iislider-slide"), slideIndex, slideWidth = slides.outerWidth(), bigphoto_layer0 = iisliderCurrentObject.find(".iislider-photo_big"), bigphoto_layer1 = iisliderCurrentObject.find(".iislider-photo_big-top"), old_bigimage, old_smallimage;
                        if ($(slide).index() !== -1) {
                            slideIndex = $(slide).index();
                        } else {
                            slideIndex = slide;
                        }
                        slides.removeClass("current");
                        $(slide).addClass("current");
                        changeImage($(slide).data("bigimage"), bigphoto_layer0, bigphoto_layer1);
                        if (opts.slideChangeType === "checkmates") {
                            if (bigphoto_layer0.data("smallimage") !== undefined) {
                                old_bigimage = bigphoto_layer0.data("bigimage");
                                old_smallimage = bigphoto_layer0.data("smallimage");
                                bigphoto_layer0.data("smallimage", $(slide).css("background-image").replace('url(', '').replace(')', ''));
                                bigphoto_layer0.data("bigimage", $(slide).data("bigimage"));
                                changeImage(old_smallimage, $(slide), $(slide).find(".up-layer"));
                                $(slide).data("bigimage", old_bigimage);
                            } else {
                                bigphoto_layer0.data("smallimage", $(slide).css("background-image").replace('url(', '').replace(')', ''));
                                bigphoto_layer0.data("bigimage", $(slide).data("bigimage"));
                                $(slide).remove();
                            }
                        }
                        if (opts.construct === "full") {
                            if (opts.ribbonType === "image") {
                                if (opts.animationType !== "none") {
                                    iisliderCurrentObject.find(".iislider-pointer").animate({left: slideIndex * (slideWidth + 30)},opts.animationDuration);
                                } else {
                                    iisliderCurrentObject.find(".iislider-pointer").css("left", (slideIndex * (slideWidth + 30) + "px"));
                                }
                            }

                            if (($(slides[slideIndex]).data("info_text"))) {
                                iisliderCurrentObject.find(".iislider-wrap").find(".iislider-slide-info").animate({opacity: 0},opts.animationDuration/2, function () {
                                    iisliderCurrentObject.find(".iislider-wrap").find(".iislider-slide-info").html($(slides[slideIndex]).data("info_text"));
                                    iisliderCurrentObject.find(".iislider-wrap").find(".iislider-slide-info").animate({opacity: 1},opts.animationDuration/2);
                                });

                            } else {
                                iisliderCurrentObject.find(".iislider-wrap").find(".iislider-slide-info").html("");
                                iisliderCurrentObject.find(".iislider-wrap").find(".iislider-slide-info").animate({opacity: 0},opts.animationDuration/2);
                            }
                        }
                    }
                }
                function slideNext(){
                    if (iisliderCurrentObject.find(".iislider-slide.current").next().length>0) {
                        activateSlide($(iisliderCurrentObject.find(".iislider-slide.current").next()));
                    }
                    else {
                        activateSlide($(iisliderCurrentObject.find(".iislider-slide")[0]));
                    }
                }
                function changeImage(newImageUrl, layer0, layer1) {
                    layer1.css("opacity","1");
                    layer0.css("background", "url('" + newImageUrl + "') no-repeat top left").css("opacity","0");
                    layer1.animate({opacity: 0},opts.animationDuration, function () {
                        $(this).css("background", "url('" + newImageUrl + "') no-repeat top left").css("opacity", "1");
                        layer1.css("opacity","0");
                    });
                    layer0.animate({opacity: 1},opts.animationDuration);
                }
                function infiniteSlide() {
                    if (opts.stopOnHover) {
                        if ((iisliderCurrentObject.find(":hover").length<1)) {
                            slideNext();
                        }
                    } else {
                        if (startslide)
                            slideNext();
                    }
                    setTimeout(infiniteSlide,opts.autoSlideDuration);
                }
                if (opts.construct === "full") {
                    if (opts.ribbonType === "image") {
                        $('<div class="iislider-wrap"><div class="iislider-slide-info"></div><div class="iislider-photo_layers"><div class="iislider-photo_big"></div><div class="iislider-photo_big-top"><img class="image-placeholder" src="'+opts.placeholderImage+'"></div></div><div class="iislider-thumbs"><div class="iislider-thumbs_ribbon"></div></div><div class="iislider-pointer"></div></div>').appendTo(this);
                    }
                    if (opts.ribbonType === "icon") {
                        $('<div class="iislider-wrap"><div class="iislider-slide-info"></div><div class="iislider-photo_layers"><div class="iislider-photo_big"></div><div class="iislider-photo_big-top"><img class="image-placeholder" src="'+opts.placeholderImage+'"></div></div><div class="iislider-thumbs"><div class="iislider-thumbs_ribbon"></div></div></div>').appendTo(this);
                    }
                }
                if (!opts.takeSlidesFromTemplate) {
                    $.each(options.slides, function () {
                        if (opts.ribbonType === "image") {
                            if (opts.slideChangeType === "checkmates") {
                                $(` <div class="iislider-slide" data-info_text="${this.info_text}" data-bigimage="${this.big_image}"><div class="up-layer" style="background: url(${this.small_image})"></div></div>`).appendTo(iisliderCurrentObject.find(".iislider-thumbs_ribbon"));
                            } else {
                                $(`<div class="iislider-slide" data-info_text="${this.info_text}" data-bigimage="${this.big_image}" style="background: url(${this.small_image})"></div>`).appendTo(iisliderCurrentObject.find(".iislider-thumbs_ribbon"));
                            }
                        } else {
                            $('<div class="iislider-slide" data-info_text="' + this.info_text + '" data-bigimage="' + this.big_image + '"></div>').appendTo(iisliderCurrentObject.find(".iislider-thumbs_ribbon"));
                        }

                    });
                } else {
                    $.each(iisliderCurrentObject.find(".iislider-slide"), function () {
                        var bgurl = $(this).css("background-image").replace('url(', '').replace(')', '');
                        $('<div class="up-layer" style="background: url(' + "'" +  + "'" + ')"></div>').appendTo($(this));
                    });
                }
                $.each(iisliderCurrentObject.find(".iislider-slide"), function () {
                    $(this).on("click", function () {
                        activateSlide(this);
                    });
                });
                if (opts.autoSlide) {
                    infiniteSlide();
                }
                activateSlide($(iisliderCurrentObject.find(".iislider-slide")[0]));
            });

        };
        $.fn.iislider.defaults = {
            autoSlide             : true,
            stopOnHover           : true,
            placeholderImage      : "/uploads/slider/01.jpg",
            autoSlideDuration     : 4000,
            animationDuration     : 300,
            placeholder           : true,
            startOnHover          : false,
            ribbonType            : "image",           // image/icon
            animationType         : "slide",           // Тип анимации поинтера (пока только slide) [slide,fade,none]
            takeSlidesFromTemplate: false,             // Брать слайды из шаблона
            slides                : {},                // Если опция выше - false, то берем слайды из массива переданного в инит плагина
            slideOffset           : 6,                 // TODO: Через сколько слайдов сдвигать ленту
            construct             : "full",            //  Конструировать слайдер - 'full' - полностью (и ленту и блок с фото),
                                                       // 'simple' - только поинтер в ленте,
                                                       // 'none' - все блоки уже есть в шаблоне
            slideChangeType       : "click"            // 'click' - простая галерея - нажатие на маленькую картинку приводит к активации слайда
                                                       // 'checkmates' - нажатие на маленькую картинку приводит к обмене изображениями с главной
        };
    })(jQuery)
};